import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, LogOut, User, HelpCircle, MessageCircle } from "lucide-react";
import ProfileModal from "../modals/ProfileModal";
import { useNavigate } from "react-router-dom";
import {
  useAssistantUiBridge,
  useOnboardingAssistant,
} from "../../assistant";

export default function ChangeUserProfile() {
  const navigate = useNavigate();
  const assistant = useOnboardingAssistant();
  const bridge = useAssistantUiBridge();
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const fullName = `${user?.fName?.S || ""} ${user?.lName?.S || ""}`.trim();
  const email = user?.email?.S || "no-email@example.com";

  return (
    <div className="relative w-full" ref={menuRef}>
      {/* Trigger */}
      <div
        className="cursor-pointer flex items-center justify-between py-2 px-3 rounded-lg bg-[#F9FAFB]"
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 text-indigo-600 font-semibold rounded-full">
            {fullName ? fullName.charAt(0).toUpperCase() : "U"}
          </div>
          <div>
            <div className="text-sm font-medium text-gray-800">
              <span className="hidden lg:inline">{fullName.slice(0, 12)}</span>
              <span className="lg:hidden">{fullName}</span>
            </div>

            <div className="text-xs text-gray-500">
              <span className="hidden lg:inline">
                {email.length > 10 ? email.slice(0, 13) + "..." : email}
              </span>
              <span className="lg:hidden">{email}</span>
            </div>
          </div>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-gray-500 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </div>

      <ProfileModal
        openProfileModal={openProfileModal}
        setOpenProfileModal={setOpenProfileModal}
      />

      {/* Dropdown menu (opens above) */}
      {open && (
        <div className="absolute bottom-full mb-2 left-0 w-full bg-white border border-gray-100 rounded-xl shadow-lg overflow-hidden">
          <div
            className="flex items-center gap-2 px-4 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-50"
            onClick={() => setOpenProfileModal(true)}
          >
            <User className="w-4 h-4 text-gray-500" />
            My Profile
          </div>

          {assistant?.enabled && (
            <div
              className="flex items-center gap-2 px-4 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-50"
              onClick={() => {
                setOpen(false);
                assistant.openAssistant?.();
              }}
            >
              <MessageCircle className="w-4 h-4 text-gray-500" />
              Setup Assistant
            </div>
          )}

          <div
            className="flex items-center gap-2 px-4 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-50"
            onClick={() => {
              setOpen(false);
              if (bridge?.openSupportComposeModal) {
                bridge.openSupportComposeModal();
              } else {
                window.location.href = "mailto:hello@twilanswer.com";
              }
            }}
          >
            <HelpCircle className="w-4 h-4 text-gray-500" />
            Contact Support
          </div>

          <div className="border-t border-gray-100 my-1" />

          <div
            className="flex items-center gap-2 px-4 py-2 cursor-pointer text-sm text-red-600 hover:bg-red-50"
            onClick={() => {
              console.info("[Auth] Logging out: user chose Sign out from user profile menu.");
              navigate("/login");
              localStorage.clear();
            }}
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </div>
        </div>
      )}
    </div>
  );
}
